import React from 'react';
import _ from 'lodash';
import { Card, CardContent, CardHeader, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useEmployees } from '../../EmployessContext';
export default function History() {
  const { rowData } = useEmployees();

  return <Stack spacing={3}>
    <Card>
      <CardHeader title="Stawki na przestrzeni lat"/>
      <CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Rok/Funkcja</TableCell>
                <TableCell align="left">Stawka dzienna</TableCell>
                <TableCell align="left">Stawka godzinowa styczeń-czerwiec</TableCell>
                <TableCell align="left">Stawka godzinowa lipiec-grudzień</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData.applications?.map(item => <TableRow key={item.id}>
                <TableCell align="left">{item.season_year}/{item.function_type_display}</TableCell>
                <TableCell align="left">{!_.isNil(item.daily_rate) ? <b>{item.daily_rate} zł</b> : null}</TableCell>
                <TableCell align="left">{!_.isNil(item.hourly_rate_summer) ? <b>{item.hourly_rate_summer} zł</b> : null}</TableCell>
                <TableCell align="left">{!_.isNil(item.hourly_rate_winter) ? <b>{item.hourly_rate_winter} zł</b> : null}</TableCell>
              </TableRow>)}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
    <Card>
      <CardHeader title="Opinie na przestrzeni lat"/>
      <CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Rok/Funkcja</TableCell>
                <TableCell align="left">opinia</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData.applications?.map(item => <TableRow key={item.id}>
                <TableCell align="left">{item.season_year}/{item.function_type_display}</TableCell>
                <TableCell align="left">{item.additional_comments}</TableCell>
              </TableRow>)}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
    <Card>
      <CardHeader title="Zakres umiejętności"/>
      <CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Rok/Funkcja</TableCell>
                <TableCell align="left">umiejętności</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData.applications?.map(item => <TableRow key={item.id}>
                <TableCell align="left">{item.season_year}/{item.function_type_display}</TableCell>
                <TableCell align="left">{item.skills}</TableCell>
              </TableRow>)}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
    <Card>
      <CardHeader title="Inne umiejętności"/>
      <CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Rok/Funkcja</TableCell>
                <TableCell align="left">umiejętności</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData.applications?.map(item => <TableRow key={item.id}>
                <TableCell align="left">{item.season_year}/{item.function_type_display}</TableCell>
                <TableCell align="left">{item.other_skills}</TableCell>
              </TableRow>)}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
    <Card>
      <CardHeader title="Pozostałe uprawnienia"/>
      <CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Rok/Funkcja</TableCell>
                <TableCell align="left">uprawnienia</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData.applications?.map(item => <TableRow key={item.id}>
                <TableCell align="left">{item.season_year}/{item.function_type_display}</TableCell>
                <TableCell align="left">{item.additional_qualifications_display}</TableCell>
              </TableRow>)}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
    <Card>
      <CardHeader title="Uprawnienia pedagogiczne"/>
      <CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Rok/Funkcja</TableCell>
                <TableCell align="left">uprawnienia</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData.applications?.map(item => <TableRow key={item.id}>
                <TableCell align="left">{item.season_year}/{item.function_type_display}</TableCell>
                <TableCell align="left">{item.pedagogical_qualifications_display}</TableCell>
              </TableRow>)}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
    <Card>
      <CardHeader title="Informacje o sobie"/>
      <CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Rok/Funkcja</TableCell>
                <TableCell align="left">informacje</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData.applications?.map(item => <TableRow key={item.id}>
                <TableCell align="left">{item.season_year}/{item.function_type_display}</TableCell>
                <TableCell align="left">{item.about_me}</TableCell>
              </TableRow>)}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  </Stack>;
}
